import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { Box, Button, Typography, Drawer, TextField, InputAdornment, IconButton, Menu, MenuItem } from '@mui/material'
import { Virtuoso } from 'react-virtuoso';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import MenuComponent from '../../components/menu/MenuComponent';
import { setGlobalSymbolID, setGlobalSymbolsData, setModifyPositionOpen, setTradeModalOpen } from '../../store/Slices/globalSymbolSlice';
import { handleCloseCreateOrder } from '../../store/Slices/panelSlice';
import { OneClickTrading as OneClickTradingAPI } from '../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import OneClickModal from '../../components/modal/OneClickTrading';
import { HiBars2 } from "react-icons/hi2";
import { IoClose, IoSearchOutline } from "react-icons/io5";
import { IoAdd } from "react-icons/io5";
import SideDrawer from '../components/SidebarMenu';
import TradeOrderModal from '../components/modals/TradeOrderModal';
import ShowSymbols from '../components/Quote/ShowSymbols';
import { MdOutlineAdsClick } from "react-icons/md";
import SimpleDetailedView from './quotes/SimpleDetailedView';
import SimpleOneClickView from './quotes/SimpleOneClickView';
import AdvanceDetailView from './quotes/AdvanceDetailView';
import AdvanceOneClickView from './quotes/AdvanceOneClickView';
import { BsHddStack } from "react-icons/bs";
import { BsFileEarmarkMinus } from "react-icons/bs";
import { BsFileEarmarkText } from "react-icons/bs";
import { setSymbol } from '../../store/Slices/symbolSlice';
import { setAmountForSymbol } from '../../store/Slices/amountSlice';

export const amountMap = new Map(JSON?.parse(localStorage?.getItem('amountMap')));

export const updateAmountMap = (symbolId, data) => {
    amountMap.set(symbolId, data)
    localStorage.setItem('amountMap', JSON.stringify([...amountMap]))
}

const Quotes = () => {
    const { darkMode } = useContext(ThemeContext);
    const { symbols } = useSelector(state => state.watchlist);
    const { userDetail } = useSelector(state => state.user);
    const { accountId } = useSelector(state => state.accountSummary)
    const id = userDetail?.id;
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isTradePanelOpen, setIsTradePanelOpen] = useState(false);
    const symbolParameterData = useSelector((state) => state.symbol.allSymbolParams, shallowEqual);
    const [hiddenSymbols, setHiddenSymbols] = useState(() => new Set(JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || []));
    const { isUserSigned, isOneclick } = useSelector((state) => state.watchlist)
    const [showOneClickModal, setShowOneClickModal] = useState(false);
    const [oneClickMode, setOneClickMode] = useState(false);
    const [sideMenuOpen, setSideMenuOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [viewMode, setViewMode] = useState('advance');
    const [viewType, setViewType] = useState('detailed');
    useEffect(() => {
        const handleHiddenSymbolsUpdate = () => {
            const updated = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
            setHiddenSymbols(new Set(updated));
        };
        window.addEventListener('hiddenSymbolsUpdated', handleHiddenSymbolsUpdate);
        return () => {
            window.removeEventListener('hiddenSymbolsUpdated', handleHiddenSymbolsUpdate);
        };
    }, [id]);

    const filteredSymbols = useMemo(() => {
        return Object.values(symbols)
            .filter(symbol => symbol.isVisible && symbol.isUsed && !hiddenSymbols.has(symbol.id))
            .filter(symbol => symbol.name.toLowerCase().includes(searchQuery.toLowerCase()));
    }, [symbols, hiddenSymbols, searchQuery]);


    const handleTrade = async (side, symbolId) => {
        console.log(amountMap.get(symbolId))
        try {
            if (!symbolId) {
                console.error("Symbol ID is missing.");
                return;
            }
            const amount = amountMap.get(symbolId) || symbolParameterData?.[symbolId]?.minimumAmountPerDeal
            const payload = { accountId: accountId, side, amount, symbolId, comment: "One-click trading" };
            const response = await OneClickTradingAPI(payload);
            if (response?.data?.id) {
                const tradeId = response.data.id;
                const symbolName = symbols?.[symbolId]?.name;
                const tradeSide = side === 1 ? "BUY" : "SELL";
                toast.success(`Trade Opened: ID #${tradeId}, ${symbolName}, ${tradeSide}, Amount: ${amount}`);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message)
            dispatch(setAmountForSymbol({ symbolId, amount: symbolParameterData?.[symbolId]?.minimumAmountPerDeal }));
        }
    }

    const handleQuoteClick = (symbol) => {
        setSelectedRow(symbol);
        setMobileMenuOpen(true);
        dispatch(setSymbol({ symbolId: symbol?.id, symbolName: symbol?.name, bid: symbol?.bid, ask: symbol?.ask }));
    };

    const handleCloseDrawer = () => {
        setMobileMenuOpen(false);
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 300);
    };
    const handleOpenOneTradeModal = () => {
        console.log("Open trade modal for:", selectedRow);
        dispatch(setTradeModalOpen(true))
        dispatch(setModifyPositionOpen(false))
        if (selectedRow) {
            dispatch(setGlobalSymbolID(selectedRow?.id))
            dispatch(setGlobalSymbolsData(selectedRow))
        }
        setIsTradePanelOpen(true);
    };
    const handleHideSymbol = (symbolId) => {
        const updatedHiddenSymbols = new Set(hiddenSymbols);
        if (symbolId !== null) {
            updatedHiddenSymbols.add(Number(symbolId));
        }

        setHiddenSymbols(updatedHiddenSymbols);
        localStorage.setItem(
            `hiddenSymbols_${id}`,
            JSON.stringify(Array.from(updatedHiddenSymbols).filter(Boolean))
        );
    };
    const handleChartClick = () => {
        if (selectedRow) {
            dispatch(setGlobalSymbolsData(selectedRow))
            dispatch(setGlobalSymbolID(selectedRow?.id))
            navigate("/chart");
            console.log(selectedRow);

        }
    };

    const handleCloseCreateOrderPanel = () => {
        dispatch(handleCloseCreateOrder());
        dispatch(setTradeModalOpen(false))
        setIsTradePanelOpen(false);
    };
    const symbolIds = Object.keys(symbols).map(Number);
    const handleHideAllSymbols = () => {
        const allHidden = new Set(symbolIds);
        setHiddenSymbols(allHidden);
        localStorage.setItem(`hiddenSymbols_${id}`, JSON.stringify(Array.from(allHidden)));
    };
    const handleShowAllSymbols = () => {
        setHiddenSymbols(new Set());
        localStorage.setItem(`hiddenSymbols_${id}`, JSON.stringify([]));
    };
    const bgImage = '/BG.png'

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleSelectSimple = () => {
        setViewMode('simple');
        setViewType('detailed');
        setAnchorEl(null);
        localStorage.setItem('quotesViewMode', 'simple');
        localStorage.setItem('quotesViewType', 'detailed');
    };

    const handleSelectAdvance = () => {
        setViewMode('advance');
        setViewType('detailed');
        setAnchorEl(null);
        localStorage.setItem('quotesViewMode', 'advance');
        localStorage.setItem('quotesViewType', 'detailed');
    };

    const toggleOneClickView = () => {
        if (!isUserSigned) {
            setShowOneClickModal(true);
            return;
        }
        setOneClickMode(true);
        const newType = viewType === 'detailed' ? 'oneclick' : 'detailed';
        setViewType(newType);
        localStorage.setItem('quotesViewType', newType);
    };
    useEffect(() => {
        const savedViewMode = localStorage.getItem('quotesViewMode');
        const savedViewType = localStorage.getItem('quotesViewType');

        if (savedViewMode) setViewMode(savedViewMode);
        if (savedViewType) {
            setViewType(savedViewType);
            if (savedViewType === 'oneclick') setOneClickMode(true);
        }
    }, []);

    return (
        <>
            {isTradePanelOpen ? (
                <TradeOrderModal open={true} onClose={handleCloseCreateOrderPanel} showCloseButton={true} />
            ) : !open ? (
                <Box sx={{ height: '100vh', overflow: 'hidden', backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', flexDirection: 'column', }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, }}>
                        <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 0.5 }}>
                            <HiBars2 onClick={() => setSideMenuOpen(true)} style={{ fontSize: 24, color: 'white' }} />
                            <Typography color='white' variant='body1' sx={{ fontSize: 18 }}> {t('Quotes')}</Typography>
                        </Box>
                        {showSearch ? (
                            <Box display="flex" flex={1}>
                                <TextField autoFocus fullWidth variant="outlined" size="small" value={searchQuery} placeholder={t('symbolName')} onChange={(e) => setSearchQuery(e.target.value)} sx={{ my: 1, bgcolor: 'white', borderRadius: 1 }}
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start"><IoSearchOutline fontSize="small" /></InputAdornment>),
                                        endAdornment: (<InputAdornment position="end"><IconButton onClick={() => {setShowSearch(false);setSearchQuery("");}}><IoClose /></IconButton></InputAdornment>),
                                    }} />
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', gap: 1, color: 'white', alignItems: 'center', }}>
                                <BsHddStack style={{ fontSize: 24 }} onClick={handleMenuOpen} />
                                <MdOutlineAdsClick style={{ fontSize: 22, cursor: 'pointer', color: viewType === 'oneclick' ? 'var(--primary)' : 'white', }} onClick={toggleOneClickView} />
                                <IoSearchOutline style={{ fontSize: 21, cursor: 'pointer' }} onClick={() => setShowSearch(true)} />
                                <IoAdd style={{ fontSize: 24, cursor: 'pointer' }} onClick={() => setOpen(true)} />
                            </Box>
                        )}
                    </Box>
                    <Box sx={{ flexGrow: 1, bgcolor: 'white', borderTopLeftRadius: 20, borderTopRightRadius: 20, overflow: 'hidden', display: 'flex', flexDirection: 'column', }}>
                        {filteredSymbols.length === 0 ? (
                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                <Button onClick={handleShowAllSymbols} variant="outlined" size="small" startIcon={<AddIcon />} sx={{ fontWeight: 500, fontSize: 14, px: 2, textTransform: 'none', }}>
                                    {t('Pleaseaddsymbols')}
                                </Button>
                            </Box>
                        ) : (
                            <Box sx={{ flexGrow: 1 }}>
                                <Virtuoso key={mobileMenuOpen ? 'drawer-open' : 'drawer-closed'} totalCount={filteredSymbols.length} style={{ height: 'calc(100vh - 115px)' }} itemContent={(index) => {
                                    const symbol = filteredSymbols[index];

                                    return (
                                        <Box key={symbol.id} sx={{ px: 2, py: 0 }}>
                                            {viewMode === 'simple' ? (
                                                viewType === 'detailed' ? (
                                                    <SimpleDetailedView symbol={symbol} handleQuoteClick={handleQuoteClick} />
                                                ) : (isUserSigned && oneClickMode ? (<SimpleOneClickView symbol={symbol} handleTrade={handleTrade} />) : null)
                                            ) : (
                                                viewType === 'detailed' ? (<AdvanceDetailView symbol={symbol} handleQuoteClick={handleQuoteClick} />
                                                ) : (isUserSigned && oneClickMode ? (<AdvanceOneClickView symbol={symbol} handleTrade={handleTrade} />) : null)
                                            )}
                                        </Box>
                                    );
                                }}
                                />
                            </Box>

                        )}
                    </Box>
                </Box>
            ) : null
            }
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem sx={{ display: 'flex', gap: 1, color: viewMode === 'simple' ? 'var(--primary)' : '' }} onClick={handleSelectSimple}>
                    <BsFileEarmarkMinus />
                    <Typography>Simple</Typography>
                </MenuItem>
                <MenuItem sx={{ display: 'flex', gap: 1, color: viewMode === 'advance' ? 'var(--primary)' : '' }} onClick={handleSelectAdvance}>
                    <BsFileEarmarkText />
                    <Typography>Advance</Typography>
                </MenuItem>
            </Menu>
            <SideDrawer open={sideMenuOpen} onClose={() => setSideMenuOpen(false)} />
            <Drawer anchor="bottom" open={mobileMenuOpen} onClose={handleCloseDrawer}>
                <MenuComponent onOpenTradeModal={handleOpenOneTradeModal} closeMenu={handleCloseDrawer} onChartClick={handleChartClick} darkMode={darkMode} onHideSymbol={handleHideSymbol} isTradePanelOpen={isTradePanelOpen} selectedRow={selectedRow} showNewDashboardOption={false} onHideAllSymbols={handleHideAllSymbols} onShowAllSymbols={handleShowAllSymbols} />
            </Drawer>
            {open && <ShowSymbols open={true} onClose={() => setOpen(false)} />}
            {!isUserSigned && (<OneClickModal isOpen={showOneClickModal} onClose={() => setShowOneClickModal(false)} onAccept={() => setShowOneClickModal(false)} />)}
        </>
    );
};

export default Quotes;
